import * as React from 'react'
import {ResponsiveValue} from '@miro-site/core'
import IconBase from '../IconBase'

const Facebook: React.FC<{
  width?: ResponsiveValue<string | number>
  height?: ResponsiveValue<string | number>
  color?: string
}> = ({width = 24, height = 24, color = 'white', ...props}) => {
  return (
    <IconBase $styles={{width, height}} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8962 21.9605C17.9992 21.5073 22 17.2209 22 12.0001C22 6.47727 17.5228 2.00012 12 2.00012C6.47715 2.00012 2 6.47727 2 12.0001C2 16.848 5.44966 20.8901 10.0282 21.8058V14.5881H7.625V11.699H10.0282V9.56754C10.0282 7.09439 11.4801 5.75012 13.6043 5.75012C14.6199 5.75012 15.4925 5.82439 15.75 5.86153V8.4535H14.2766C13.118 8.4535 12.8962 9.01795 12.8962 9.85718V11.699H15.6499L15.2923 14.5881H12.8962V21.9605Z"
        fill={color}
      />
    </IconBase>
  )
}

export default Facebook
